import { SingleSelectDropdown, TextInput } from "@carbon6/c6-frontend-design";
import { useMemo, type ReactNode } from "react";
import { hatcheryDropdownModes } from "@/app/theme";
import { listTimeZoneOptions } from "./timeZoneOptions";

/**
 * cron 시간대 입력. 생성 위저드와 편집 다이얼로그가 같은 컨트롤을 쓴다. 브라우저가 IANA
 * 목록을 주면 검색 가능한 드롭다운이고, 주지 않으면 이름을 직접 입력하는 텍스트 입력이다.
 * 값은 초안의 문자열 그대로다(빈 값 = 기본 Asia/Seoul, 판정은 `resolveScheduleTimezone`).
 */
export function TimeZoneField({
  value,
  onChange,
}: {
  value: string;
  onChange: (timezone: string) => void;
}): ReactNode {
  const options = useMemo(() => listTimeZoneOptions(value), [value]);
  if (options.length === 0) {
    return (
      <TextInput
        value={value}
        placeholder="Asia/Seoul"
        onChange={(event) => onChange(event.target.value)}
      />
    );
  }
  return (
    <SingleSelectDropdown
      mode={hatcheryDropdownModes.default}
      label="시간대"
      searchable
      searchPlaceholder="시간대 검색"
      fullWidth
      placeholder="Asia/Seoul (기본)"
      value={value.trim() === "" ? null : value.trim()}
      options={options}
      onValueChange={onChange}
    />
  );
}
